import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../../../util/Util";
import {
  addDeskVideo,
  checkIfCompanyUrlExists,
  checkIfDeskVideoExists,
  createCompany,
  updateCompany,
} from "../../../../actions/clients/company/company";
import CustomLabel from "../../../sub/CustomLabel";
import { Card } from "react-bootstrap";
import FileDropZone from "../../../sub/FileDropZone";
import APIUrl from "../../../../APIUrl";

class CompanyAddGeneralInfoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company_name: undefined,
      url: undefined,
      company_nameError: null,
      urlError: null,
      access_pharmamad: false,
      access_module_desk: true,
      access_module_home: false,
      access_module_store: false,
      access_order_from_desk: false,
      disabledDropZone: false,
      videoExists: false,
    };
    if (this.props.company !== undefined) {
      this.state = {
        company_name: this.props.company.name,
        url: this.props.company.url,
        access_pharmamad: this.props.company.access.access_pharmamad,
        access_module_desk: this.props.company.access.access_module_desk,
        access_module_home: this.props.company.access.access_module_home,
        access_module_store: this.props.company.access.access_module_store,
        access_order_from_desk:
          this.props.company.access.access_order_from_desk,
        disabledDropZone: false,
        videoExists: false,
      };
    }
  }

  componentDidMount() {
    if (this.props.company && this.props.company._id) {
      this.props.onCheckIfDeskVideoExists(
        this.props.company._id,
        () => {
          this.setState({ videoExists: true });
        },
        () => {
          this.setState({ videoExists: false });
        },
      );
    }
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    let data = {};

    // No previous error
    if (this.hasError()) return;

    if (this.props.company === undefined) {
      data = {
        name: this.state.company_name,
        url: this.state.url,
        access: {
          access_pharmamad: this.state.access_pharmamad,
          access_module_desk: this.state.access_module_desk,
          access_module_home: this.state.access_module_home,
          access_module_store: this.state.access_module_store,
          access_order_from_desk: this.state.access_order_from_desk,
        },
      };

      // Send company information and redirect on success
      this.props.onCompanyCreate(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    } else {
      data = {
        _id: this.props.company._id,
        name: this.state.company_name,
        url: this.state.url,
        access: {
          access_pharmamad: this.state.access_pharmamad,
          access_module_desk: this.state.access_module_desk,
          access_module_home: this.state.access_module_home,
          access_module_store: this.state.access_module_store,
          access_order_from_desk: this.state.access_order_from_desk,
        },
      };
      // Send company information and redirect on success
      this.props.onCompanyEdit(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    }
  }

  hasEmptyField() {
    return !this.state.company_name || !this.state.url;
  }

  hasError() {
    return this.state.urlError || this.state.company_nameError;
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    // Check if company_name is not empty
    if (field === "company_name" && !Util.emptyString(value)) {
      this.setState({ company_nameError: null });
      // Check if company_name < 50
      if (value.length > 50) {
        this.setState({
          company_nameError: <FormattedMessage id="Character.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[A-Z.\s0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          company_nameError: <FormattedMessage id="Character.Type" />,
        });
      }
    }

    // Check if email is not empty and not already taken
    if (field === "url" && !Util.emptyString(value)) {
      this.setState({ urlError: null });
      this.props.onCheckIfCompanyUrlExists(value, () => {
        this.setState({
          urlError: <FormattedMessage id="URL.Already.Taken" />,
        });
      });

      if (value.length > 20) {
        this.setState({
          urlError: <FormattedMessage id="Character.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[a-z0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          urlError: <FormattedMessage id="Character.Type.AlphaNum" />,
        });
      }
    }

    if (field === "access_pharmamad" && this.state.access_pharmamad === false) {
      this.setState({
        access_module_desk: true,
        access_module_home: true,
        access_module_store: true,
      });
    } else if (
      field === "access_pharmamad" &&
      this.state.access_pharmamad === true
    ) {
      this.setState({
        access_module_desk: true,
        access_module_home: false,
        access_module_store: false,
      });
    }

    if (
      (field === "access_module_desk" ||
        field === "access_module_home" ||
        field === "access_module_store") &&
      this.state.access_pharmamad === true
    ) {
      this.setState({ access_pharmamad: false });
    }
  }

  onDropFile(file) {
    let formData = new FormData();
    formData.append("desk_movie", file);

    this.setState({ disabledDropZone: true });

    var successCallback = () => {
      this.setState({ disabledDropZone: false });
    };

    this.props.onAddDeskVideo(
      this.props.company._id,
      formData,
      successCallback,
    );
  }

  render() {
    return (
      <form onSubmit={(e) => this.handleSubmit(e)} autoComplete="off">
        <div className="form-group row">
          <label htmlFor="date" className="col-5 col-form-label">
            <FormattedMessage id="Name" />
          </label>
          <div className="col-7">
            <input
              type="text"
              id="company_name"
              name="company_name"
              className="form-control"
              defaultValue={this.state.company_name}
              onInput={(e) =>
                (e.target.value = ("" + e.target.value).toUpperCase())
              }
              onChange={(e) =>
                this.onChange("company_name", "" + e.target.value)
              }
            />
            <small className="text-danger">
              {this.state.company_nameError}
            </small>
          </div>
        </div>

        <div className="form-group row">
          <label htmlFor="date" className="col-5 col-form-label">
            <FormattedMessage id="URL.Login" />
          </label>
          <div className="col-7">
            <input
              type="text"
              id="url"
              name="url"
              defaultValue={this.state.url}
              onInput={(e) =>
                (e.target.value = ("" + e.target.value).toLowerCase())
              }
              className="form-control"
              onChange={(e) => this.onChange("url", e.target.value)}
            />
            <small className="text-danger">{this.state.urlError}</small>
          </div>
        </div>

        {this.props.company !== undefined &&
          this.props.company.access.access_module_store && (
            <>
              {this.state.videoExists && (
                <div className="form-group row">
                  <div className="offset-md-5 col-7">
                    <video
                      src={
                        APIUrl.getDeskVideo +
                        this.props.company._id +
                        "/" +
                        Math.random()
                      }
                      controls
                      style={{ width: "100%", height: "100%" }}
                    ></video>
                  </div>
                </div>
              )}
              <div className="form-group row">
                <label className="col-5 col-form-label">
                  <FormattedMessage id="Video.Desk" />
                </label>
                <div className="col-7">
                  <FileDropZone
                    disabled={this.state.disabledDropZone}
                    onDropFile={(file) => this.onDropFile(file)}
                    acceptedExtensions={["mp4"]}
                    multiple={false}
                  />
                </div>
              </div>
            </>
          )}

        <div className="mb-2 mt-5">
          <p>
            <b>
              <FormattedMessage id="Access.Rights" />
            </b>
          </p>
        </div>
        <Card className="mt-4">
          <Card.Header className="bg-white">
            <div className="row">
              <div className="col">
                <CustomLabel
                  label={this.props.intl.formatMessage({
                    id: "Access.PHARMA.MAD",
                  })}
                  htmlFor={"access_pharmamad"}
                  labelClassName="col-10"
                />
              </div>
              <div className="form-check col-2 align-content-center text-center">
                <input
                  className=""
                  id={"access_pharmamad"}
                  checked={this.state.access_pharmamad}
                  onChange={(e) =>
                    this.onChange(
                      "access_pharmamad",
                      !this.state.access_pharmamad,
                    )
                  }
                  type="checkbox"
                />
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="row">
              <div className="col">
                <CustomLabel
                  label={this.props.intl.formatMessage({
                    id: "Access.HOME",
                  })}
                  htmlFor="access_module_home"
                  labelClassName="col-10"
                />
              </div>
              <div className="form-check col-2 align-content-center text-center">
                <input
                  type="checkbox"
                  id="access_module_home"
                  checked={this.state.access_module_home}
                  onChange={(e) =>
                    this.onChange(
                      "access_module_home",
                      !this.state.access_module_home,
                    )
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <CustomLabel
                  label={this.props.intl.formatMessage({
                    id: "Access.STORE",
                  })}
                  htmlFor="access_module_store"
                  labelClassName="col-10"
                />
              </div>
              <div className="form-check col-2 align-content-center text-center">
                <input
                  type="checkbox"
                  id="access_module_store"
                  checked={this.state.access_module_store}
                  onChange={(e) =>
                    this.onChange(
                      "access_module_store",
                      !this.state.access_module_store,
                    )
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <CustomLabel
                  label={this.props.intl.formatMessage({
                    id: "Access.DESK",
                  })}
                  htmlFor="access_module_desk"
                  labelClassName="col-10"
                />
              </div>
              <div className="form-check col-2 align-content-center text-center">
                <input
                  type="checkbox"
                  id="access_module_desk"
                  checked={this.state.access_module_desk}
                  disabled
                  // onChange={(e) =>
                  //   this.onChange(
                  //     "access_module_desk",
                  //     !this.state.access_module_desk,
                  //   )
                  // }
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col">
                <CustomLabel
                  label={this.props.intl.formatMessage({
                    id: "Access.Order.From.Desk",
                  })}
                  htmlFor="access_order_from_desk"
                  labelClassName="col-10"
                />
              </div>
              <div className="form-check col-2 align-content-center text-center">
                <input
                  type="checkbox"
                  id="access_order_from_desk"
                  checked={this.state.access_order_from_desk}
                  disabled={
                    !this.state.access_module_desk ||
                    !this.state.access_module_store
                  }
                  onChange={(e) =>
                    this.onChange(
                      "access_order_from_desk",
                      !this.state.access_order_from_desk,
                    )
                  }
                />
              </div>
            </div>
          </Card.Body>
        </Card>

        {this.props.company === undefined && (
          <div className="row mt-4">
            <div className="col-4 m-auto">
              <button
                type="submit"
                disabled={
                  this.hasEmptyField() ||
                  this.state.company_nameError ||
                  this.state.urlError
                }
                className="btn btn-info btn-block button-info right"
              >
                <FormattedMessage id="Create" />
              </button>
            </div>
          </div>
        )}
        {this.props.company !== undefined && (
          <div className="row mt-4">
            <div className="col-4 m-auto">
              <button
                type="submit"
                disabled={
                  this.hasEmptyField() ||
                  this.state.company_nameError ||
                  this.state.urlError
                }
                className="btn btn-info btn-block button-info right"
              >
                <FormattedMessage id="Edit" />
              </button>
            </div>
          </div>
        )}
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheckIfCompanyUrlExists: (url, existsCallback, noExistsCallback) =>
      checkIfCompanyUrlExists(url, existsCallback, noExistsCallback),
    onCompanyCreate: (data, successCallback, failureCallback) =>
      dispatch(createCompany(data, successCallback, failureCallback)),
    onCompanyEdit: (data, successCallback, failureCallback) =>
      dispatch(updateCompany(data, successCallback, failureCallback)),
    onCheckIfDeskVideoExists: (companyId, existsCallback, noExistsCallback) =>
      checkIfDeskVideoExists(companyId, existsCallback, noExistsCallback),
    onAddDeskVideo: (companyId, data, successCallback) =>
      dispatch(addDeskVideo(companyId, data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyAddGeneralInfoModal));
